import React from 'react';
import { Collapse, Modal } from 'antd';
const { Panel } = Collapse;

const FAQ = (props) => {
  return (
    <>
      <Modal title="FAQ" visible={props.visible} onOk={props.handleOk(false)} onCancel={props.handleCancel(false)}>
        <h1>CÁC CÂU HỎI THƯỜNG GẶP KHI SỬ DỤNG SÁCH SỐ</h1>
        <Collapse>
          <Panel header="1. Đăng ký tài khoản sách số thế nào?" key="1">
            <p>- Ở màn hình chính, chọn Đăng ký giáo viên nếu bạn là giáo viên, chọn Đăng ký học sinh nếu bạn là học sinh.</p>
            <p>- Điền đầy đủ thông tin, chọn Đăng ký.</p>
            <p>- Sau khi đăng ký xong, Đăng nhập để truy cập sách số.</p>
          </Panel>
          <Panel header="2. Quên mật khẩu thì làm thế nào?" key="2">
            <p>- Coming soon</p>
          </Panel>
          <Panel header="3. Học sinh kích hoạt sách thế nào?" key="3">
            <p>- Lần đầu học sinh đăng nhập vào trang sách số, màn hình sẽ hiện mục Kích hoạt sách. Nhập mã để kích hoạt sách.</p>
          </Panel>
          <Panel header="4. Học sinh lấy mã kích hoạt sách ở đâu?" key="4">
            <p>- Xem mặt sau trang bìa sách giáo khoa bản cứng để lấy mã kích hoạt.</p>
          </Panel>
          <Panel header="5. Tại sao không kích hoạt được sách?" key="5">
            <p>- Nếu không kích hoạt được sách, lý do là mã kích hoạt bị sai hoặc mã này đã được sử dụng trước đó.</p>
          </Panel>
          <Panel header="6. Các bước để giáo viên tạo lớp học?" key="6">
            <p>- Chọn Lớp học thanh bên trái</p>
            <p>- Chọn Tạo lớp học</p>
            <p>- Điền thông tin: Khoá học, tên lớp, thời gian</p>
            <p>- Chọn Tạo</p>
          </Panel>
          <Panel header="7. Cho học sinh vào lớp như thế nào?" key="7">
            <p>- Sau khi tạo lớp học xong, giáo viên sẽ thấy bảng Danh sách lớp.</p>
            <p>- Trong bảng Danh sách lớp, chọn nút Chi tiết cho lớp mình muốn chuyển học sinh.</p>
            <p>- Click vào các ô vuông để chọn học sinh</p>
            <p>- Chọn mũi tên &gt; để chuyển học sinh đã chọn vào lớp</p>
            <p>- Làm ngược lại nếu muốn cho học sinh ra khỏi lớp</p>
          </Panel>
          <Panel header="8. Tại sao nội dung bài học không hiển thị?" key="8">
            <p>- Một học sinh chỉ có thể tham gia một lớp học.</p>
            <p>- Nếu click vào bài học mà nội dung không hiển thị, hãy vào mục trợ giúp và yêu cầu trợ giúp từ nhà xuất bản.</p>
          </Panel>
          <Panel header="9. Sách số có thể sử dụng ngoại tuyến (offline) không?" key="9">
            <p>- Bạn có thể sử dụng sách số ngoại tuyến.</p>
          </Panel>
        </Collapse>
      </Modal>
    </>
  );
};

export default FAQ